<div class="cgi-container">
  <div *ngIf="!!formula" class="cgi-image" [class.selected]="formula.selected" [attr.style]="tileBgStyle()"
       (pointerdown)="mouseDown()" (pointerup)="mouseUp()">
    <img src="assets/images/swatch-texture-4-vert-hl.png" alt="hair texture">
    <div [ngClass]="dynamicFont(formula.title)">{{formula.title}}</div>
  </div>
</div>
